// @flow
const deliveryStatusMapping = {
  CANCELLED: 'cancelled',
  COMPLETED: 'delivered',
  CONFIRMED: 'inPreparation',
  CREATED: 'inPreparation',
  IN_TRANSIT: 'shipped',
};

export const deliveryStatusFormatter = (status: string): 'cancelled' | 'shipped' | 'delivered' | 'inPreparation' =>
  deliveryStatusMapping[status] || 'inPreparation';
